import { Link } from 'react-router-dom'

export interface BreadcrumbItem {
  label: string
  to?: string
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
}

function ChevronRightIcon() {
  return (
    <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--text-3)', flexShrink: 0 }}>
      <polyline points="9 18 15 12 9 6" />
    </svg>
  )
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 13,
        fontFamily: 'var(--font)',
        color: 'var(--text-3)',
        animation: 'in-up 400ms var(--ease) both',
        marginBottom: 20,
      }}
    >
      {items.map((item, i) => {
        const isLast = i === items.length - 1
        return (
          <span key={i} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {i > 0 && <ChevronRightIcon />}
            {item.to && !isLast ? (
              <Link
                to={item.to}
                style={{
                  color: 'var(--text-2)',
                  textDecoration: 'none',
                  transition: 'color var(--dur-f)',
                  cursor: 'pointer',
                }}
                onMouseEnter={e => (e.currentTarget.style.color = 'var(--text-1)')}
                onMouseLeave={e => (e.currentTarget.style.color = 'var(--text-2)')}
              >
                {item.label}
              </Link>
            ) : (
              <span style={{ color: isLast ? 'var(--text-1)' : 'var(--text-2)' }}>
                {item.label}
              </span>
            )}
          </span>
        )
      })}
    </nav>
  )
}
